export const MISSION_PREVIEW_EVENT = 'willow:mission-preview';

export interface MissionCommand {
    command: string;
    lat?: number;
    lon?: number;
    altitude_m?: number;
    duration_s?: number;
    [key: string]: unknown;
}

export interface CompiledMission {
    success: boolean;
    mission_type?: string;
    mavsdk?: {
        sequence: MissionCommand[];
    };
    metrics?: {
        speed_mph: number;
        distance_m: number;
        distance_mi: number;
        travel_time_s: number;
        wait_time_s: number;
        total_time_min: number;
        waypoints_visited: number;
    };
    flight_executed: false;
}

let latestMissionPreview: CompiledMission | null = null;

export function getLatestMissionPreview(): CompiledMission | null {
    return latestMissionPreview;
}

export function publishMissionPreview(mission: CompiledMission): void {
    if (
        mission.success !== true ||
        mission.flight_executed !== false ||
        !mission.mavsdk?.sequence ||
        !mission.metrics
    ) {
        throw new Error('Mission preview requires a validated compilation result');
    }

    latestMissionPreview = mission;

    window.dispatchEvent(
        new CustomEvent<CompiledMission>(MISSION_PREVIEW_EVENT, {
            detail: mission
        })
    );
}
